import React from 'react';
import { CATEGORIES } from '../../../constants/categories';

export const ListingHero = ({ categoryId }) => {
  const category = CATEGORIES[categoryId] || {
    title: "Discover Activities",
    description: "Explore a variety of activities and experiences curated just for you."
  };

  return (
    <div className="hero">
      <div className="hero-container">
        <div className="hero-box">
          <div className="hero-center">
            <h3
              // data-w-id="92f0cc8f-fd6a-6cf4-2f16-2b23880cada0"
              style={{ opacity: 1 }}
              className="heading-italic black"
            >
              We’ve got plans. You just show up.
            </h3>
            <h1
              // data-w-id="a67385c1-53ce-c13d-66a5-09c83ff80c93"
              style={{ opacity: 1 }}
              className="hero-h1 black"
            >
              {category.title}
            </h1>
            <div
              // data-w-id="422a2023-0550-c073-e22b-cd796c4ab55d"
              style={{ opacity: 1 }}
              className="home-desc"
            >
              <p className="hero-p black">
                {category.description}
              </p>
            </div>
          </div>
          <div
            // data-w-id="a8a57870-34a1-f445-76d6-6bfc3e41b6aa"
            style={{ opacity: 1 }}
            className="hero-bottom"
          />
        </div>
      </div>
    </div>
  );
};
